import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public displayOnMobile: boolean;
  constructor() { }

  ngOnInit(): void {
    if (window.screen.width >= 500) {
      this.displayOnMobile = true
    } else {
      this.displayOnMobile = false
    }
  }

}
